import _jsx from '@babel/runtime/helpers/jsx';
import { useState } from 'react';
import 'prop-types';
import { Card } from '@andes/card';
import { Accordion } from '@andes/accordion';
const namespace = "seo-ui-extended-menu-mobile";
const ExtendedMenuMobile = _ref => {
  let {
    title = "",
    menu = []
  } = _ref;
  const [activeIds, setActiveIds] = useState([0]);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace)
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__header")
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: "".concat(namespace, "__header__title")
  }, void 0, title)), /*#__PURE__*/_jsx(Card, {
    shadow: "outline"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__body ").concat(namespace, "__accordion-container")
  }, void 0, menu.map((_ref2, index) => {
    let {
      title = "",
      url: titleUrl = "",
      children: links = []
    } = _ref2;
    return /*#__PURE__*/_jsx(Accordion, {
      className: "accordion-list",
      title: /*#__PURE__*/_jsx("a", {
        className: "".concat(namespace, "__group_title"),
        href: titleUrl
      }, void 0, title),
      id: title === null || title === void 0 ? void 0 : title.replace(/\s/g, ''),
      showDivider: index + 1 < menu.length,
      expanded: activeIds.includes(index),
      onChange: () => setActiveIds(activeIds.includes(index) ? [] : [index])
    }, title === null || title === void 0 ? void 0 : title.replace(/\s/g, ''), links.length > 0 && /*#__PURE__*/_jsx("ul", {
      className: "".concat(namespace, "__list")
    }, void 0, links.map(_ref3 => {
      let {
        text = "",
        url = ""
      } = _ref3;
      return /*#__PURE__*/_jsx("li", {
        className: "".concat(namespace, "__link")
      }, text === null || text === void 0 ? void 0 : text.replace(/\s/g, ''), /*#__PURE__*/_jsx("a", {
        className: "".concat(namespace, "__anchor"),
        href: url
      }, void 0, text));
    })));
  }))));
};
ExtendedMenuMobile.displayName = "ExtendedMenuMobile";
export { ExtendedMenuMobile as default };
